<div style="background-color: #eaeaea" class="vh-100 pt-5">

  <div *ngIf="cookiesAllowed !== undefined && cookiesAllowed === false">
    <h4 class="text-center">Debido a la configuración de seguridad de su navegador no es posible iniciar sesión en OKTA</h4>
  </div>

  <div *ngIf="cookiesAllowed !== undefined && cookiesAllowed === true">
    <h6 class="text-center">Bienvenido</h6>
    <p class="text-center">Redirigiendo para iniciar sesión en OKTA</p>
  </div>

  <div class="row justify-content-center">
    <div class="col-6 max-vh-75 text-center">
      <img src="/assets/png/akibaLogo1.png" class="img-fluid img-thumbnail" alt="Akiba">
    </div>

    <iframe id="iframeCookies" src="https://jabil-akiba.uc.r.appspot.com/helper/cookies" style="display:none"></iframe>

  </div>

  <p class="text-center">Ver {{version}}</p>

</div>
